'use client'

import PropTypes from 'prop-types'
import { Modal } from '@repo/ui/Modal'
import { Logo } from '@repo/ui/Logo'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import { openSupportEmail } from '@repo/utils/emailSupport'
import MUIButton from '@mui/material/Button'

export const AccountMenuAboutPopup = ({ open, handleClose }) => {
  const { companyCode, databaseSuffix, version, environmentName } = useGlobalSettingsStore()

  return (
    <Modal open={open} handleClose={handleClose} sx={{ width: '400px' }}>
      <MUIStack direction="column" alignItems="center" justifyContent="center" data-testid="AccountMenuAboutPopup">
        <Logo sx={{ width: '52px', height: 'auto', margin: '0 auto 4px', color: '#5073C3' }} />

        <MUIStack
          direction="column"
          alignItems="center"
          justifyContent="center"
          gap={8}
          sx={{ padding: '30px', width: '100%' }}
        >
          <MUIStack
            sx={{
              display: 'grid',
              gridTemplateColumns: 'auto minmax(0, 1fr)',
              columnGap: 2,
              rowGap: 1,
              width: '100%'
            }}
          >
            <MUITypography variant="subtitle2">Version number</MUITypography>
            <MUITypography variant="body2" sx={{ wordBreak: 'break-word', textAlign: 'right' }}>
              {version}
            </MUITypography>

            <MUITypography variant="subtitle2">Company name</MUITypography>
            <MUITypography variant="body2" sx={{ wordBreak: 'break-word', textAlign: 'right' }}>
              {companyCode}
            </MUITypography>

            <MUITypography variant="subtitle2">Database suffix</MUITypography>
            <MUITypography variant="body2" sx={{ wordBreak: 'break-word', textAlign: 'right' }}>
              {databaseSuffix}
            </MUITypography>

            <MUITypography variant="subtitle2">Environment</MUITypography>
            <MUITypography variant="body2" sx={{ wordBreak: 'break-word', textAlign: 'right' }}>
              {environmentName}
            </MUITypography>

            <MUITypography variant="subtitle2">Build</MUITypography>
            <MUITypography variant="body2" sx={{ wordBreak: 'break-word', textAlign: 'right' }}>
              {import.meta.env.VITE_SPA_OSPREY_BUILD_NUMBER || 'N/A'}
            </MUITypography>
          </MUIStack>

          <MUIButton variant="contained" color="primary" sx={{ mt: 0 }} onClick={openSupportEmail}>
            Report an issue
          </MUIButton>
        </MUIStack>
      </MUIStack>
    </Modal>
  )
}

AccountMenuAboutPopup.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func
}
